import { HttpErrorResponse } from '@angular/common/http';
import { Action } from '@ngrx/store';
import { LoginRequestDto } from '@services/authentication/model/loginRequestDto';
import { OAuth2TokensDto } from '@services/authentication/model/oAuth2TokensDto';
import { PermissionsModel } from '@shared/models/permission.model';
import {WebOwnProfileModel} from "@services/back-office/model/webOwnProfileModel";

export enum LoginActionTypes {
  Login = '[Login] Login',
  LoginSuccess = '[Login] Login Success',
  LoginFailure = '[Login] Login Failure',
  LogOut = '[Login] LogOut',
  LoadUser = '[Login] Load User',
  LoadUserSuccess = '[Login] Load User Success',
  LoadUserFailure = '[Login] Load User Failure',
  SetUser = '[Login] Set User',
  SetPermissions = '[Login] Set Permissions',
  SetInitialState = '[Login] Set Initial State',
}

/** Login */
export class Login implements Action {
  readonly type = LoginActionTypes.Login;
  constructor(public payload: LoginRequestDto) { }
}

export class LoginSuccess implements Action {
  readonly type = LoginActionTypes.LoginSuccess;
  constructor(public payload: OAuth2TokensDto) { }
}

export class LoginFailure implements Action {
  readonly type = LoginActionTypes.LoginFailure;
  constructor(public payload: HttpErrorResponse) { }
}

/** LogOut */
export class LogOut implements Action {
  readonly type = LoginActionTypes.LogOut;
}

/** Load Current User */
export class LoadUser implements Action {
  readonly type = LoginActionTypes.LoadUser;
}

export class LoadUserSuccess implements Action {
  readonly type = LoginActionTypes.LoadUserSuccess;
  constructor(public payload: WebOwnProfileModel) {}
}

export class LoadUserFailure implements Action {
  readonly type = LoginActionTypes.LoadUserFailure;
  constructor(public payload?: any) {}
}

/** Set Current User */
export class SetUser implements Action {
  readonly type = LoginActionTypes.SetUser;
  constructor(public payload: WebOwnProfileModel) {}
}

/** Set Permissions */
export class SetPermissions implements Action {
  readonly type = LoginActionTypes.SetPermissions;
  constructor(public payload: PermissionsModel[]) { }
}

/** Set Initial State */
export class SetInitialState implements Action {
  readonly type = LoginActionTypes.SetInitialState;
}

export type LoginActions =
  | Login
  | LoginSuccess
  | LoginFailure
  | LogOut
  | LoadUser
  | LoadUserSuccess
  | LoadUserFailure
  | SetUser
  | SetPermissions
  | SetInitialState
  ;

